<script setup>
import {v4 as uuidv4} from "uuid"
import {computed} from "vue"

import InputRadio from "@/components/form/InputRadio.vue"
import {useHelpers} from "@/useHelpers"

const { formatMoney } = useHelpers()

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: ""
  },
  label: {
    type: String,
    required: true
  },
  subscription: {
    type: Object,
    required: true
  }
})

const inputValue = computed( {
  get() {
    return props.modelValue
  },
  set(newValue) {
    emits('update:modelValue', newValue)
  }
})

const emits = defineEmits(["update:modelValue"])

const id = computed(() => `radio-${uuidv4()}`)

</script>

<template>
  <InputRadio
      :id="id"
      v-model="inputValue"
      name="payment_frequency"
      :label="subscription.user_label"
      :value="subscription.code"
  >
    <template #rightLabel>
      {{ formatMoney(subscription.price) }}
    </template>
  </InputRadio>
</template>